var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopMd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 558,
    height: 546,
    viewBox: "0 0 558 546",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_15387)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5819 550.516C83.0685 545.325 80.5559 537.515 76.6146 528.321C74.5686 523.547 72.9309 520.252 68.6474 511.817C53.7052 482.396 52.3372 480.567 53.2817 476.534C55.2972 467.926 64.9816 461.5 73.2001 456.046C80.7293 451.05 83.9544 450.965 85.72 446.941C88.5472 440.497 82.3311 436.036 78.3219 421.901C75.0628 410.41 75.5382 400.551 76.0455 390.032C76.5604 379.353 78.2668 370.791 78.8909 367.837C81.8083 354.023 84.6269 351.206 84.5819 341.659C84.541 332.989 82.1737 326.242 81.1673 323.448C79.1374 317.812 77.468 315.995 69.2163 300.684C66.3242 295.318 64.8785 292.635 64.0944 291.01C60.9787 284.549 54.6794 271.173 53.8509 254.019C53.5138 247.04 53.3452 243.55 54.989 239.222C57.0367 233.831 60.0951 231.623 66.3709 222.719C70.0748 217.464 71.9098 214.824 72.6309 213.044C76.7338 202.914 72.6906 192.29 71.4928 189.142C66.0842 174.931 57.5366 174.786 54.4201 164.102C52.3094 156.867 54.5823 151.284 59.5417 137.924C76.6716 91.7775 77.5869 82.8611 85.1508 81.5839C94.2213 80.0523 107.6 90.3936 110.191 92.3967C115.336 96.3741 117.575 99.6011 122.142 99.7949C129.337 100.1 135.073 92.5696 136.938 90.1203C146.322 77.8005 141.074 69.3131 147.182 58.2512C153.88 46.1214 167.974 42.2331 184.173 37.7639C195.461 34.6496 212.203 30.0307 230.269 36.0566C249.408 42.4404 254.24 55.5028 268.967 53.6984C273.683 53.1207 278.371 50.4678 287.748 45.1621C302.027 37.0824 304.664 32.0252 313.357 30.3657C319.806 29.1346 323.433 30.9483 333.844 33.7803C353.741 39.1923 351.058 35.4417 389.615 42.8857C389.615 42.8857 402.061 45.2886 418.639 48.0075C427.454 49.4534 429.126 49.6253 431.159 49.7148C444.494 50.3018 446.64 46.1636 459.613 45.1621C465.531 44.7052 463.045 45.7239 492.051 49.7148C494.513 50.0534 498.173 50.5471 501.726 53.1294C506.455 56.5655 505.717 59.8646 509.124 63.373C513.128 67.4961 518.18 67.0948 536.251 68.1154C536.251 68.1154 544.783 68.5974 552.944 69.2536C564.909 70.2157 575.363 181.065 576.467 574.228",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5819 550.516C83.0685 545.325 80.5559 537.515 76.6146 528.321C74.5686 523.547 72.9309 520.252 68.6474 511.817C53.7052 482.396 52.3372 480.567 53.2817 476.534C55.2972 467.926 64.9816 461.5 73.2 456.046C80.7293 451.05 83.9544 450.965 85.72 446.941C88.5472 440.497 82.3311 436.036 78.3219 421.901C75.0628 410.41 75.5382 400.551 76.0455 390.032C76.5604 379.353 78.2668 370.791 78.8909 367.837C81.8083 354.023 84.6269 351.206 84.5819 341.659C84.541 332.989 82.1737 326.242 81.1673 323.448C79.1374 317.812 77.468 315.995 69.2163 300.684C66.3242 295.318 64.8785 292.635 64.0944 291.01C60.9787 284.549 54.6794 271.173 53.8509 254.019C53.5138 247.04 53.3452 243.55 54.989 239.222C57.0367 233.831 60.0951 231.623 66.3709 222.719C70.0748 217.464 71.9098 214.824 72.6309 213.044C76.7338 202.914 72.6906 192.29 71.4928 189.142C66.0842 174.931 57.5366 174.786 54.4201 164.102C52.3094 156.867 54.5823 151.284 59.5417 137.924C76.6716 91.7775 77.5869 82.8611 85.1508 81.5839C94.2213 80.0523 107.6 90.3936 110.191 92.3967C115.336 96.3741 117.575 99.6011 122.142 99.7949C129.337 100.1 135.073 92.5696 136.938 90.1203C146.322 77.8005 141.073 69.3131 147.182 58.2512C153.88 46.1214 167.974 42.2331 184.173 37.7639C195.461 34.6496 212.203 30.0307 230.269 36.0566C249.408 42.4404 254.24 55.5028 268.967 53.6984C273.683 53.1207 278.371 50.4678 287.748 45.1621C302.027 37.0824 304.664 32.0252 313.357 30.3657C319.806 29.1346 323.433 30.9483 333.844 33.7803C353.741 39.1923 351.058 35.4417 389.615 42.8857C389.615 42.8857 402.061 45.2886 418.639 48.0075C427.454 49.4534 429.126 49.6253 431.159 49.7148C444.494 50.3018 446.64 46.1636 459.613 45.1621C465.531 44.7052 463.045 45.7239 492.051 49.7148C494.513 50.0534 498.173 50.5471 501.726 53.1294C506.455 56.5655 505.717 59.8646 509.124 63.373C513.128 67.4961 518.18 67.0948 536.251 68.1154C536.251 68.1154 544.783 68.5974 552.944 69.2536C564.909 70.2157 575.363 181.065 576.467 574.228",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M547.626 15.001H6.60938V532.874H547.626V15.001Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.191 553.741C120.865 552.294 119.957 543.628 114.362 534.013C108.834 524.513 104.505 524.006 102.221 516.56C99.2731 506.947 103.336 497.503 105.257 493.038C108.379 485.778 110.155 486.888 118.156 473.309C123.555 464.147 125.037 459.754 125.744 457.375C127.629 451.024 127.868 445.949 128.02 442.199C128.355 433.93 128.79 423.19 123.468 413.365C119.154 405.402 116.225 407.578 109.05 398.189C105.653 393.743 96.2608 381.453 97.6686 367.079C98.1775 361.883 100.072 356.673 103.739 346.592C106.622 338.666 107.208 338.817 107.533 335.969C108.805 324.82 99.9533 321.345 101.463 312.446C102.506 306.295 106.899 306.986 111.327 296.512C112.903 292.783 114.811 288.268 114.362 282.853C114.012 278.634 112.33 275.071 105.257 266.16C92.9244 250.625 89.344 250.506 86.287 242.637C85.2784 240.041 82.205 232.131 84.7692 223.668C87.7676 213.772 95.5724 212.699 95.3924 206.216C95.1652 198.038 82.6479 196.101 82.493 187.246C82.4259 183.41 84.7651 183.226 88.5632 173.588C91.2951 166.655 92.661 163.189 92.3572 159.93C91.3696 149.334 78.1517 146.907 77.9401 137.925C77.8263 133.092 81.5199 128.138 85.528 125.784C98.1134 118.392 112.169 137.588 131.056 132.613C141.122 129.962 147.256 121.841 152.302 115.161C162.13 102.15 167.027 83.9819 168.236 79.4979C170.845 69.8191 170.609 66.402 173.548 65.0809C182.914 60.8701 201.786 88.1788 206.934 84.8094C208.914 83.514 206.452 79.2634 206.934 70.3924C207.213 65.2676 207.886 52.8806 216.04 46.87C223.836 41.123 236.622 42.5674 244.115 48.3875C250.156 53.0797 248.106 57.0042 257.773 71.91C266.352 85.1384 270.671 86.2178 272.949 86.327C276.884 86.5156 279.919 84.058 283.572 81.0155C294.033 72.3019 291.856 66.5368 298.748 61.287C303.047 58.0115 304.372 59.8922 332.135 56.7342C339.268 55.9227 342.648 55.4042 348.828 55.2166C366.105 54.6923 370.222 57.8177 371.591 59.0106C375.977 62.8311 374.42 66.2037 378.421 68.8749C384.015 72.6101 389.613 67.7204 400.426 66.5985C417.386 64.8387 418.886 75.2839 436.088 73.4276C444.148 72.5579 449.586 69.6429 457.335 72.6688C462.124 74.539 461.444 76.1982 465.681 77.9803C476.094 82.3598 483.211 73.6065 497.551 74.9452C501.772 75.3393 498.895 75.8867 513.485 80.2567C529.908 85.1754 537.315 85.6086 543.837 84.8094C548.448 84.2443 550.362 83.3392 551.424 83.2918C572.586 82.3479 727.352 400.578 569.635 560.57C418.994 713.385 126.355 576.696 121.191 553.741Z",
    fill: "#9E1F63",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.359 549.189C272.2 541.948 280.99 530.242 282.053 515.043C283.12 499.766 275.34 495.843 277.5 484.692C281.236 465.408 306.263 468.042 326.821 442.199C342.624 422.335 333.683 413.429 350.344 396.672C358.441 388.529 359.628 391.562 396.63 370.873C415.217 360.481 420.606 356.535 433.052 352.662C435.118 352.019 439.511 350.068 445.654 349.037C453.244 347.763 464.418 345.887 470.232 351.145C477.987 358.157 473.37 375.344 470.232 387.567C466.156 403.446 459.997 411.908 462.644 414.124C465.67 416.657 472.83 404.858 488.443 402.742C500.438 401.117 508.511 406.414 516.518 400.466C517.772 399.535 519.124 397.822 521.83 394.396C530.22 383.772 530.242 379.406 534.729 376.185C534.729 376.185 541.816 371.097 552.94 374.667C562.959 377.883 571.197 408.489 551.423 552.983",
    fill: "#9E1F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.359 549.189C272.2 541.948 280.99 530.242 282.053 515.043C283.12 499.766 275.34 495.843 277.5 484.692C281.236 465.408 306.263 468.042 326.821 442.199C342.624 422.335 333.683 413.429 350.344 396.672C358.441 388.529 359.628 391.562 396.63 370.873C415.217 360.481 420.606 356.535 433.052 352.662C435.118 352.019 439.511 350.068 445.654 349.037C453.244 347.763 464.418 345.887 470.232 351.145C477.987 358.157 473.37 375.344 470.232 387.567C466.156 403.446 459.997 411.908 462.644 414.124C465.67 416.657 472.83 404.858 488.443 402.742C500.438 401.117 508.511 406.414 516.518 400.466C517.772 399.535 519.124 397.822 521.83 394.396C530.22 383.772 530.242 379.406 534.729 376.185C534.729 376.185 541.816 371.097 552.94 374.667C562.959 377.883 571.197 408.489 551.423 552.983",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.325 549.947C283.788 546.942 282.68 538.377 287.613 530.218C290.333 525.72 293.772 523.193 295.96 521.619C303.179 516.424 310.477 515.376 314.929 514.79C320.307 514.081 324.134 514.447 330.358 515.042C340.026 515.967 345.915 516.53 352.616 519.595C361.762 523.779 361.12 527.454 370.068 530.471C376.023 532.479 381.159 532.487 385.75 532.495C393.887 532.508 398.253 532.514 401.937 529.712C406.458 526.274 404.666 522.629 409.019 514.031C410.616 510.877 415.521 501.19 425.207 496.326C431.327 493.252 433.513 495.039 442.659 490.508C446.899 488.408 447.398 487.544 452.017 485.45C456.068 483.613 460.459 481.622 466.434 480.897C469.415 480.535 476.243 479.783 483.633 482.668C490.5 485.347 491.172 488.558 495.774 488.485C498.417 488.443 499.021 487.371 507.156 482.668C513.364 479.078 516.469 477.284 520.561 475.838C525.399 474.13 524.457 475.347 532.702 473.056C538.818 471.357 541.841 469.991 547.119 470.021C549.508 470.035 551.734 470.331 552.43 470.527C562.85 473.463 553.69 545.046 552.683 552.729",
    fill: "#9E1F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.325 549.947C283.788 546.942 282.68 538.377 287.613 530.218C290.333 525.72 293.772 523.193 295.96 521.619C303.179 516.424 310.477 515.376 314.929 514.79C320.307 514.081 324.134 514.447 330.358 515.042C340.026 515.967 345.915 516.53 352.616 519.595C361.762 523.779 361.12 527.454 370.068 530.471C376.023 532.479 381.159 532.487 385.75 532.495C393.887 532.508 398.253 532.514 401.937 529.712C406.458 526.274 404.666 522.629 409.019 514.031C410.616 510.877 415.521 501.19 425.207 496.326C431.327 493.252 433.513 495.039 442.659 490.508C446.899 488.408 447.398 487.544 452.017 485.45C456.068 483.613 460.459 481.622 466.434 480.897C469.415 480.535 476.243 479.783 483.633 482.668C490.5 485.347 491.172 488.558 495.774 488.485C498.417 488.443 499.021 487.371 507.156 482.668C513.364 479.078 516.469 477.284 520.561 475.838C525.399 474.13 524.457 475.347 532.702 473.056C538.818 471.357 541.841 469.991 547.119 470.021C549.508 470.035 551.734 470.331 552.43 470.527C562.85 473.463 553.69 545.046 552.683 552.729",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.573 549.189C129.107 536.714 126.171 526.801 124.227 520.355C119.002 503.036 116.809 497.047 119.674 490.003C121.64 485.171 125.031 482.482 131.814 477.104C131.814 477.104 137.883 472.292 159.131 461.928C164.728 458.145 167.901 454.184 169.754 451.305C172.738 446.668 172.581 444.396 176.583 437.647C179.823 432.182 181.443 429.449 184.171 427.783C190.631 423.835 196.293 428 200.105 424.747C204.786 420.754 201.621 409.894 200.864 407.295C194.131 384.186 175.693 383.624 171.272 364.803C168.05 351.091 174.714 338.096 176.583 334.451C180.826 326.176 183.598 326.654 191 316.999C195.618 310.976 212.432 289.045 206.935 266.16C205.627 260.715 204.619 256.519 200.864 253.261C191.498 245.134 178.421 254.462 157.613 247.191C153.245 245.664 148.791 243.496 145.473 241.879C135.378 236.963 130.331 234.505 129.538 232.015C126.796 223.402 146.624 203.145 168.995 200.905C177.713 200.032 179.844 202.593 197.07 201.663C207.135 201.12 214.589 199.804 221.352 194.834C223.231 193.453 226.426 191.105 228.181 188.005C237.653 171.273 198.017 145.303 203.899 116.679C206.005 106.432 213.734 96.8704 222.869 93.9154C235.593 89.7993 249.304 99.0629 258.532 105.297C258.532 105.297 262.335 107.866 282.055 125.785C291.724 126.28 304.79 125.223 314.682 116.679C318.707 113.203 318.38 111.793 323.029 106.815C337.876 90.9164 358.546 86.7388 358.692 87.0863C358.811 87.3679 346.017 91.9537 346.552 93.9154C347.053 95.7556 358.565 92.6402 378.421 91.639C397.75 90.6643 399.421 92.9825 414.084 90.8802C423.535 89.5252 425.312 88.208 436.089 87.0863C449.093 85.7328 455.595 85.0561 461.129 87.8451C473.884 94.2729 477.417 113.48 477.064 113.644C476.804 113.764 472.724 104.438 472.511 104.538C472.23 104.671 475.559 122.683 488.445 130.337C490.557 131.592 489.85 130.741 510.45 136.408C524.692 140.325 520.835 139.578 526.385 140.96C535.113 143.134 538.316 143.404 543.078 146.272C546.445 148.299 548.735 150.508 551.425 153.101C551.425 153.101 556.544 158.037 560.53 163.724C595.736 213.951 574.188 344.316 574.188 344.316C565.716 395.572 558.415 467.039 562.807 559.053",
    fill: "#9E1F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.573 549.189C129.107 536.713 126.171 526.801 124.227 520.355C119.002 503.036 116.809 497.047 119.674 490.003C121.64 485.171 125.031 482.482 131.814 477.104C131.814 477.104 137.883 472.292 159.131 461.928C164.728 458.145 167.901 454.184 169.754 451.305C172.738 446.668 172.581 444.396 176.583 437.647C179.823 432.182 181.443 429.449 184.171 427.783C190.631 423.835 196.293 428 200.105 424.747C204.786 420.754 201.621 409.894 200.864 407.295C194.131 384.186 175.693 383.624 171.272 364.803C168.05 351.091 174.714 338.096 176.583 334.451C180.826 326.177 183.598 326.654 191 316.999C195.618 310.976 212.432 289.045 206.935 266.16C205.627 260.715 204.619 256.519 200.864 253.261C191.498 245.134 178.421 254.462 157.613 247.191C153.245 245.664 148.791 243.496 145.473 241.879C135.378 236.963 130.331 234.505 129.538 232.015C126.796 223.402 146.624 203.145 168.995 200.905C177.713 200.032 179.844 202.593 197.07 201.663C207.135 201.12 214.589 199.804 221.352 194.834C223.231 193.453 226.426 191.105 228.181 188.005C237.653 171.273 198.017 145.303 203.899 116.679C206.005 106.432 213.734 96.8704 222.869 93.9154C235.593 89.7993 249.304 99.0629 258.532 105.297C258.532 105.297 262.335 107.866 282.055 125.785C291.724 126.28 304.79 125.223 314.682 116.679C318.707 113.203 318.38 111.793 323.029 106.815C337.876 90.9164 358.546 86.7388 358.692 87.0863C358.811 87.3679 346.017 91.9537 346.552 93.9154C347.053 95.7556 358.565 92.6402 378.421 91.639C397.75 90.6643 399.421 92.9825 414.084 90.8802C423.535 89.5252 425.312 88.208 436.089 87.0863C449.093 85.7328 455.595 85.0561 461.129 87.8451C473.884 94.2729 477.417 113.48 477.064 113.644C476.804 113.764 472.724 104.438 472.511 104.538C472.23 104.671 475.559 122.683 488.445 130.337C490.557 131.592 489.85 130.741 510.45 136.408C524.692 140.325 520.835 139.578 526.385 140.96C535.113 143.134 538.316 143.404 543.078 146.272C546.445 148.299 548.735 150.508 551.425 153.101C551.425 153.101 556.544 158.037 560.53 163.724C595.736 213.951 574.188 344.316 574.188 344.316C565.716 395.572 558.415 467.039 562.807 559.053",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.653 549.948C209.381 540.983 207.952 536.126 206.929 534.013C205.549 531.162 203.205 529.79 191.754 524.149C178.585 517.662 175.654 516.506 175.819 515.043C176.177 511.867 190.559 512.432 204.653 504.42C206.492 503.375 209.315 501.622 211.482 498.35C214.494 493.804 214.464 489.009 214.517 486.209C214.764 473.127 217.337 475.872 218.311 458.134C218.948 446.537 217.789 446.437 218.311 430.059C218.612 420.617 218.784 415.8 219.829 411.089C222.375 399.608 227.169 392.396 230.452 387.567C234.528 381.569 236.626 378.568 239.557 378.461C245.105 378.259 251.01 387.842 253.215 396.672C257.452 413.63 246.431 421.349 249.421 443.717C250.266 450.031 251.791 454.262 253.215 458.134C255.574 464.547 259.371 474.873 263.839 474.827C266.874 474.796 268.311 469.995 272.944 461.169C280.307 447.143 282.067 448.999 288.878 436.129C296.534 421.664 300.372 414.413 297.984 406.536C296.965 403.176 296.018 403.675 286.602 389.843C282.192 383.364 279.986 380.125 278.255 376.944C274.167 369.431 269.509 360.871 269.909 350.386C270.289 340.416 275.071 333.191 278.255 328.381C286.69 315.64 292.48 317.982 298.743 307.135C303.581 298.755 306.11 286.988 304.054 276.025C302.381 267.105 298.921 265.371 300.26 260.09C301.96 253.39 308.496 252.377 321.506 243.397C331.832 236.269 338.641 229.365 343.511 224.427C348.911 218.952 353.181 213.442 361.722 202.422C372.087 189.049 377.353 182.202 381.451 174.347C383.916 169.621 387.788 162.093 390.556 151.583C392.306 144.941 393.588 137.21 394.35 132.614C396.755 118.113 396.426 114.24 399.662 112.126C405.068 108.594 414.307 113.97 416.355 115.162C433.102 124.906 438.991 147.04 437.601 147.789C436.502 148.382 429.035 136.576 429.254 136.408C429.476 136.237 438.186 147.507 455.812 169.036C461.443 175.913 461.676 176.13 466.435 181.935C491.938 213.046 503.93 229.795 505.133 228.98C506.183 228.269 498.849 214.319 498.304 214.563C497.584 214.886 505.729 241.358 514.239 241.12C517.999 241.016 518.269 235.795 525.621 230.497C531.729 226.096 542.142 222.062 547.625 225.945C550.099 227.696 551.462 230.982 551.419 244.914C551.367 262.207 549.233 268.119 549.143 277.542C548.979 294.698 555.866 294.134 557.49 311.688C559.878 337.513 545.976 349.59 553.696 361.768C558.861 369.915 568.506 369.504 574.183 372.391C590.428 380.652 593.595 425.133 556.731 557.535",
    fill: "#9E1F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.653 549.948C209.381 540.983 207.952 536.126 206.929 534.013C205.549 531.162 203.205 529.79 191.754 524.149C178.585 517.662 175.654 516.506 175.819 515.043C176.177 511.867 190.559 512.432 204.653 504.42C206.492 503.375 209.315 501.622 211.482 498.35C214.494 493.804 214.464 489.009 214.517 486.209C214.764 473.127 217.337 475.872 218.311 458.134C218.948 446.537 217.789 446.437 218.311 430.059C218.612 420.617 218.784 415.8 219.829 411.089C222.375 399.608 227.169 392.396 230.452 387.567C234.528 381.569 236.626 378.568 239.557 378.461C245.105 378.259 251.01 387.842 253.215 396.672C257.452 413.63 246.431 421.349 249.421 443.717C250.266 450.031 251.791 454.262 253.215 458.134C255.574 464.547 259.371 474.873 263.839 474.827C266.874 474.796 268.311 469.995 272.944 461.169C280.307 447.143 282.067 448.999 288.878 436.129C296.534 421.664 300.372 414.413 297.984 406.536C296.965 403.176 296.018 403.675 286.602 389.843C282.192 383.364 279.986 380.125 278.255 376.944C274.167 369.431 269.509 360.871 269.909 350.386C270.289 340.416 275.071 333.191 278.255 328.381C286.69 315.64 292.48 317.982 298.743 307.135C303.581 298.755 306.11 286.988 304.054 276.025C302.381 267.105 298.921 265.371 300.26 260.09C301.96 253.39 308.496 252.377 321.506 243.397C331.832 236.269 338.641 229.365 343.511 224.427C348.911 218.952 353.181 213.442 361.722 202.422C372.087 189.049 377.353 182.202 381.451 174.347C383.916 169.621 387.788 162.093 390.556 151.583C392.306 144.941 393.588 137.21 394.35 132.614C396.755 118.113 396.426 114.24 399.662 112.126C405.068 108.594 414.307 113.97 416.355 115.162C433.102 124.906 438.991 147.04 437.601 147.789C436.502 148.382 429.035 136.576 429.254 136.408C429.476 136.237 438.186 147.507 455.812 169.036C461.443 175.913 461.676 176.13 466.435 181.935C491.938 213.046 503.93 229.795 505.133 228.98C506.183 228.269 498.849 214.319 498.304 214.563C497.584 214.886 505.729 241.358 514.239 241.12C517.999 241.016 518.269 235.795 525.621 230.497C531.729 226.096 542.142 222.062 547.625 225.945C550.099 227.696 551.462 230.982 551.419 244.914C551.367 262.207 549.233 268.119 549.143 277.542C548.979 294.698 555.866 294.134 557.49 311.688C559.878 337.513 545.976 349.59 553.696 361.768C558.861 369.915 568.506 369.504 574.183 372.391C590.428 380.652 593.595 425.133 556.731 557.535",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M682.316 631.924V-12.1992L547.631 -12.1992V631.924H682.316Z",
    fill: "#6C3950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.063 85.9121H203.52V207.354H245.063V85.9121Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.39 309.862H102.25V351.335H235.39V309.862Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.66 372.959H111.891V415.072H237.66V372.959Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.916 442.958H98.8047V470.021H210.916V442.958Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.916 516.371H98.8047V532.875H210.916V516.371Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.665 415.072H210.918V532.874H237.665V415.072Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.241 244.345H115.309V279.059H201.241V244.345Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.066 232.963H201.246V255.727H245.066V232.963Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.812 174.347H39.0469V190.85H175.812V174.347Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.782 128.818H94.8242V154.997H174.782V128.818Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.707 96.9492H147.18V118.575H192.707V96.9492Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.244 59.3896H39.0469V78.1697H102.244V59.3896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.37 63.373H122.703V85.911H166.37V63.373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.241 38.9033H126.121V55.407H201.241V38.9033Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.461 77.6006H282.621V100.364H495.461V77.6006Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.261 81.0156H513.668V118.576H543.261V81.0156Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.816 123.129H282.621V190.851H304.816V123.129Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.978 154.997H304.816V179.468H334.978V154.997Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.41 118.576H371.402V167.234H404.41V118.576Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.61 123.129H434.57V162.965H459.61V123.129Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.076 162.965H500.02V266.54H521.076V162.965Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.017 131.665H482.375V167.233H500.017V131.665Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.954 131.665H500.02V154.998H515.954V131.665Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.11 214.753H277.121V283.613H303.11V214.753Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.884 219.368H302.031V242.638H310.884V219.368Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.292 210.263H310.887V247.443H324.292V210.263Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.136 196.352H334.977V242.638H354.136V196.352Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.783 174.852H360.969V205.709H380.783V174.852Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.035 309.862H277.121V362.147H302.035V309.862Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.99 304.858H289.578V316.62H308.99V304.858Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.875 345.833H319.898V362.147H370.875V345.833Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.964 362.146H324.289V371.631H360.964V362.146Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.112 366.89H277.121V461.169H287.112V366.89Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.985 392.878H287.109V446.246H297.985V392.878Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.232 323.828H317.59V341.28H362.232V323.828Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.117 279.312H308.992V298.788H352.117V279.312Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.85 248.329H379.742V273.938H399.85V248.329Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.799 252.122H411.047V283.612H432.799V252.122Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.475 279.312H367.547V298.788H404.475V279.312Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.905 298.788H367.547V316.114H376.905V298.788Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.805 316.114H367.547V329.899H389.805V316.114Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.839 194.454H469.094V217.028H484.839V194.454Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.199 200.715H484.844V217.029H491.199V200.715Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.734 45.0986H423.691V66.4712H459.734V45.0986Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.474 45.0986H470.102V66.4712H491.474V45.0986Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.396 39.2822H272.754V63.3738H371.396V39.2822Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.061 40.4473H376.168V68.1165H407.061V40.4473Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.406 44.7842H218.504V76.4636H242.406V44.7842Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.347 44.7842H199.914V76.4636H210.347V44.7842Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.101 44.7842H242.41V61.6672H248.101V44.7842Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.505 44.7842H210.348V66.22H218.505V44.7842Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.25 96.9492H59.7305V122.748H102.25V96.9492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2275 123.508H39.0469V150.255H76.2275V123.508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6504 346.086H58.9688V405.019H74.6504V346.086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.793 361.009H74.6523V394.016H86.793V361.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8066 423.229H38.7383V436.129H87.8066V423.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8023 408.034H75.9102V423.229H87.8023V408.034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9338 444.729H54.4141V460.157H77.9338V444.729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.982 473.975H53.0508V491.906H70.982V473.975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9091 473.975H70.9766V485.957H75.9091V473.975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8023 473.057H75.9102V501.385H87.8023V473.057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.093 473.975H100.453V497.845H134.093V473.975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.299 470.021H116.633V473.973H128.299V470.021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0444 294.046H59.7305V341.66H76.0444V294.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7305 309.862H38.4844V326.163H59.7305V309.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7275 262.555H54.793V294.803H70.7275V262.555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7305 288.924H38.4844V299.547H59.7305V288.924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8171 257.624H38.4844V269.575H61.8171V257.624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0007 226.323H39.8086V253.45H51.0007V226.323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.242 229.942H60.9297V254.019H102.242V229.942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.842 272.23H80.5938V290.631H112.842V272.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.309 249.214H96.7188V263.599H115.309V249.214Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.514 159.171H179.043V200.335H203.514V159.171Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.456 184.103L431.078 169.679L391.263 220.408L409.641 234.832L449.456 184.103Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.569 230.957L477.125 219.62L444.413 261.299L458.857 272.636L491.569 230.957Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.67566,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.132 532.874H-23.4609V637.587H645.132V532.874Z",
    fill: "#6C3950"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_15387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 557.432,
    height: 545.233,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopMd);
export default __webpack_public_path__ + "static/media/desktop-md.e495ad23e38b4072a7b4f35081767d95.svg";
export { ForwardRef as ReactComponent };